type PageContainerProps = {
  children: React.ReactNode;
  className?: string;
  as?: "div" | "section";
};

export function PageContainer({
  children,
  className = "",
  as: Tag = "div",
}: PageContainerProps) {
  return (
    <Tag className={`mx-auto w-full max-w-page px-4 md:px-6 lg:px-8 ${className}`}>
      {children}
    </Tag>
  );
}
